export default __webpack_public_path__ + "static/media/image4.00032124.jpeg";